// Chat category enum
export enum ChatCategory {
  GENERAL = "GENERAL",
  HTS_CLASSIFICATION = "HTS_CLASSIFICATION",
  CBP_AUDIT = "CBP_AUDIT",
}

// Message sender enum - unified format
export enum MessageSender {
  USER = "USER",
  AI = "AI"
}

// Context interface for type safety
export interface ChatContext {
  [key: string]: unknown;
}

// Frontend input types
export interface ChatCreateInput {
  title: string;
  clientId?: string;
  category?: ChatCategory;
  context?: ChatContext;
  sessionId?: string;
}

export interface MessageCreateInput {
  content: string;
  sender: MessageSender;
  context?: ChatContext;
}

export interface ChatMessageInput {
  content: string;
  source: MessageSender; // Now using unified enum
  context?: ChatContext;
}

export interface ChatFilterInput {
  category?: ChatCategory;
  clientId?: string;
  pageNo?: number;
  pageSize?: number;
  isActive?: boolean;
}

// Unified chat message interface - same for backend and frontend
export interface ChatMessage {
  _id: string;
  content: string;
  source: MessageSender; // Backend uses 'source' field name
  messageOrder: number;
  createdAt: string;
  llmMetadata?: {
    model?: string;
    confidence?: number;
    mcpToolsUsed?: string[];
    hasInternalData?: boolean;
  };
}

// Unified chat interface - same for backend and frontend
export interface Chat {
  _id: string;
  title: string;
  category?: ChatCategory;
  context?: Record<string, unknown>;
  totalMessages?: number;
  firstMessageAt?: string;
  lastActivityAt?: string;
  messages?: ChatMessage[];
}

export interface ChatResponse {
  data: Chat;
}

export interface ChatsResponse {
  data: Chat[];
  meta: {
    countDocs: number;
    pageNo: number;
    pageSize: number;
  };
}

export interface CreateChatResponse {
  createChat: ChatResponse;
}

export interface GetChatsResponse {
  chats: ChatsResponse;
}

export interface GetChatResponse {
  chat: ChatResponse;
}

export interface SendMessageResponse {
  sendMessage: {
    data: Chat;
  };
}

export interface UpdateChatResponse {
  updateChat: ChatResponse;
}

export interface DeleteChatResponse {
  deleteChat: {
    data: boolean;
  };
}

// Simple types for UI components
export interface UIChatMessage {
  id: string;
  content: string;
  sender: MessageSender;
  timestamp: string;
  messageOrder?: number; // Optional, used for sorting messages in correct order
  llmMetadata?: {
    model?: string;
    confidence?: number;
    mcpToolsUsed?: string[];
    hasInternalData?: boolean;
    thinking?: string[];
    processingSteps?: string[];
    toolCalls?: Array<{
      toolName?: string;
      name?: string;
      arguments?: any;
      args?: any;
      timestamp?: string;
      success?: boolean;
    }>;
  };
}

export interface UIChatSession {
  id: string;
  title: string;
  timestamp: string;
  lastMessage: string;
  messages: UIChatMessage[];
}
